

<div class="object-actions mt-3">

  @if (showContingentEditButton) {
    <button class="btn btn-primary border btn-small" [disabled]="allowContingentEdit === false || existingEndpoints.length === 0" (click)="manageContingents()" >
      <i class="fa fa-users"></i>
      <span>{{'COMPONENTS.VENUE-DEFINITION.UNPLACED-TICKETS-LIST.BUTTON.QUOTAS' | translate}}</span>
    </button>
    <span class="separator"></span>
  }

  @if (eventPlacementEventId === null) {
    <button class="btn btn-primary border btn-small" title="Huidige sectie / locatie beheren." [disabled]="!canAddPositions" (click)="addOrUpdateTickets(1, true, null)">
      <i class="far fa-plus-square"></i>
      <span>{{'COMPONENTS.VENUE-DEFINITION.UNPLACED-TICKETS-LIST.BUTTON.AMOUNT-OF-CHANGES' | translate}}</span>
    </button>
  }

  @if (eventPlacementEventId !== null) {
    <button class="btn btn-primary border btn-small" [disabled]="!canChangeEventCapacity()" (click)="changeEventCapacity()">
      <i class="far fa-edit"></i>
      <span>{{'COMPONENTS.VENUE-DEFINITION.UNPLACED-TICKETS-LIST.BUTTON.AMOUNT-OF-CHANGES' | translate}}</span>
    </button>

    <hr>

    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
      <button class="btn btn-primary border btn-small" (click)="downloadBarcodesImportFile()">
        <i class="fa-solid fa-file-download"></i>
        <span>{{'COMPONENTS.VENUE-DEFINITION.UNPLACED-TICKETS-LIST.BUTTON.DOWNLOAD-BARCODE-IMPORT-TEMPLATE' | translate}}</span>
      </button>

      <button class="btn btn-primary border btn-small" (click)="importBarcodes()">
        <i class="fa-solid fa-file-import"></i>
        <span>{{'COMPONENTS.VENUE-DEFINITION.UNPLACED-TICKETS-LIST.BUTTON.IMPORT-BARCODES' | translate}}</span>
      </button>

      <button class="btn btn-primary border btn-small" (click)="resetBarcodes()">
        <i class="fa-solid fa-file-import"></i>
        <span>{{'COMPONENTS.VENUE-DEFINITION.UNPLACED-TICKETS-LIST.BUTTON.RESET-BARCODES' | translate}}</span>
      </button>
    </div>

    
  }

</div>


<p class="py-3">{{'COMPONENTS.VENUE-DEFINITION.UNPLACED-TICKETS-LIST.AMOUNT-OF-TICKETS-OF-THIS-TYPE' | translate}}<b> {{existingEndpoints.length | number }}</b></p>

@if (eventPlacementEventId !== null) {
  <p class="py-3">{{'COMPONENTS.VENUE-DEFINITION.UNPLACED-TICKETS-LIST.AMOUNT-OF-IMPORTED-BARCODES' | translate: { allExternalBarcodes: allExternalBarcodesCount, soldExternalBarcodes: soldExternalBarcodesCount } }}</p>
}